import { showAlert } from 'components/shared/Alert/Alert';

// An export can fail on the fetch (timeout, permission, business error). Reporting it as
// an empty result would read as "nothing to export", so the cause is surfaced instead.
export const showExportError = (error) =>
  showAlert({
    title: 'Export failed',
    message: error?.message || 'The export data could not be loaded. Please try again.',
    color: 'danger'
  });
